import { Box, ClickAwayListener, Grid, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/**API, UTIL*/
import ClinicApi, { BillInterface, BranchInterface } from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import ProductTypesApi from 'api/setting/default-products/product-type.api'
import { getBranch, numberFormat, toBuddhistYear } from 'utils/app.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import SearchPatients from 'component/SearchPatients'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import FilterSelect from 'component/Select/FilterSelect'
import TransactionRevenueList from './TransactionRevenueList'

/**STYLED */
import AboutUs from 'api/admin/clinic-manage/about.api'
import ComponentApi from 'api/components-api'
import ReportPermissionApi from 'api/setting/personnel-managements/report-permission.api'
import OperativeTypeApi from 'api/setting/treatments/operative-type.api'
import InputCheckbox from 'component/Input/InputCheckbox'
import { colors } from 'constants/theme'
import { CustomFilterDoctor, ListFilterDoctors } from 'features/counter/appointment/head-appointment'
import { SpanClearFilter } from 'features/report/useStyled'
import DropdownButton from 'new-components/buttons/dropdown-button'
import PageModal from 'new-components/modal/page-modal'
import { dateTimeToView } from 'utils/date.utils'
import TransactionRevenueAll from './transaction-revenue-all'

type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}
interface DentistInterface {
  dentistId: number
  dentistFullname: string
}
export default function TransactionRevenue() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const componentRefPDF = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange

  const [branchId, setBranchId] = useState<number>(getBranch())
  const [branches, setBranches] = useState<any>([])
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
  const [rowCount, setRowCount] = useState<number>(0)
  const [billStatus, setBillStatus] = useState<string>('ALL')
  const [prefix, setPrefix] = useState<string>('ALL')
  const [receiptPrefix, setReceiptPrefix] = useState<any[]>([])
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')

  const [patientId, setPatientId] = useState<number>(0)

  const [itemCode, setItemCode] = useState<any[]>([])
  const [groupCode, setGroupCode] = useState<string>('')

  const [productTypes, setProductTypes] = useState<any[]>([])
  const [operativeTypes, setOperativeTypes] = useState<any[]>([])
  const [operativeTypeId, setOperativeTypeId] = useState<number>(0)
  const [operativeId, setOperativeId] = useState<number>(0)
  const [group, setGroup] = useState<string>('')

  const [typeSelected, setTypeSelected] = useState({ productTypeName: '', productTypeId: 0, group: '' })
  const [codeSelected, setCodeSelected] = useState({ productCode: ``, productId: 0, group: `` })

  const [doctorId, setDoctorId] = useState<number>(0)
  const [doctors, setDoctors] = useState<Doctors[]>([])

  const [transactionData, setTransactionData] = useState<any>([])
  const [transactionDataExport, setTransactionDataExport] = useState<any[]>([])
  const [transactionPage, setTransactionPage] = useState<number>(1)
  const [transactionLimitPage, setTransactionLimitPage] = useState<number>(10)

  const [fetchData, setFetchData] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const [patientFilter, setPatientFilter] = useState<string>(t('REPORT.REPORT_GROUP.ALL'))
  const [selectDoctors, setSelectDoctors] = useState<any[]>(['ALL'])
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [transactionRevenueList, setTransactionRevenueList] = useState<any>([])
  const [crm, setCrm] = useState(null)
  const [reportId, setReportId] = useState(0)

  const fetchAboutUs = async () => {
    await AboutUs.findAboutUs().then(async (res) => {
      setCrm(res.data?.useCrm)
      await ReportPermissionApi.reportTransactionRevenueList(branchId).then((resp: any) => {
        const data = resp.data?.permission
        const dataCrm = data?.some((item: any) => "amountVoucher" in item) ? data : data.flatMap((item: any) => item.amountTrementRight !== undefined ? [item, { amountVoucher: '0' }, { amountPromotion: '0' }] : item)
        const dataNotCrm = data.filter((item: any) => !("amountVoucher" in item) && !("amountPromotion" in item))
        setTransactionRevenueList(resp?.data?.permission.length !== 0 ? (res.data?.useCrm === '1' ? dataCrm : dataNotCrm) : defaultTransactionRevenue)
      }).catch(() => {
        setTransactionRevenueList(defaultTransactionRevenue)
      })
    })
  }

  const setDoc = (data: any) => {
    const sortedSelectData = data.sort((a: any, b: any) => {
      const idA = a.dentistId
      const idB = b.dentistId
      return selectDoctors.indexOf(idA) - selectDoctors.indexOf(idB)
    })
    return sortedSelectData
  }

  const getAllFilter = () => {
    return [
      [
        t('SEARCH_BY'),
        patientFilter,
        t('REPORT.FILTER.BRANCH'),
        _.get(_.find(branches, { branchId: branchId }), 'branchName' || 'branchNameEn'),
        'วันที่เริ่มต้น',
        rangeDate[0] ? toBuddhistYear(moment(rangeDate[0]), 'DD/MM/YYYY') : '-',
        'วันที่สิ้นสุด',
        rangeDate[1] ? toBuddhistYear(moment(rangeDate[1]), 'DD/MM/YYYY') : '-',
        t('REPORT.FILTER.RECEIPT_STATUS'),
        billStatus === 'ALL' ? t(`REPORT.FILTER.ALL`) : t(`REPORT.FILTER.BILL.${billStatus}`)
      ],
      [
        t('REPORT.FILTER.RECEIPT_TYPE'),
        prefix === 'ALL' ? t(`REPORT.FILTER.ALL`) : prefix,
        t('REPORT.FILTER.OPERATIVE_TYPE'),
        typeSelected.productTypeName || t('REPORT.REPORT_GROUP.ALL'),
        t('REPORT.FILTER.OPERATIVE_CODE'),
        codeSelected.productCode || t('REPORT.REPORT_GROUP.ALL'),
        t('REPORT.FILTER.DOCTOR'),
        _.isEmpty(selectDoctors)
          ? ` ${t('REPORT.FILTER.NO_SELECT')}`
          : selectDoctors.filter((i) => typeof i === 'number').length === doctors.length
            ? `${t('REPORT.FILTER.ALL')}`
            : `${setDoc(doctors.filter((d: any) => selectDoctors.includes(d.userId)))
              ?.map((d: any) => d.fullname)
              .slice(0, 3) // เเสดงเเค่ 3 คนเเรก
              .join(', ')}`
      ]
    ]
  }
  const defaultTransactionRevenue = () => {
    return [
      { datePaid: "0" },
      { billStatus: "0" },
      { billNo: "0" },
      { cnNumber: "0" },
      { branchCnNumber: "0" },
      { snCode: "0" },
      { patientFullname: "0" },
      { doctorFullname: "0" },
      { itemTypeName: "0" },
      { code: "0" },
      { itemName: "0" },
      { price: "0" },
      { qty: "0" },
      { priceTreatment: "0" },
      { dfPercent: "0" },
      { dfOriginal: "0" },
      { cfPercent: "0" },
      { cfOriginal: "0" },
      { dfDiscount: "0" },
      { cfDiscount: "0" },
      { discountTotal: "0" },
      { additionalTotal: "0" },
      { dfNetOriginal: "0" },
      { cfNetOriginal: "0" },
      { total: "0" },
      { PayTreatment: "0" },
      { amountPaidOverdue: "0" },
      { amountPaidAdvance: "0" },
      { amountPaid: "0" },
      { amountCash: "0" },
      { amountTransfer: "0" },
      { amountCredit: "0" },
      { amountDebit: "0" },
      { dfAmountCredit: "0" },
      { cfAmountCredit: "0" },
      { amountTrementRight: "0" },
      { amountVoucher: "0" },
      { amountPromotion: "0" },
      { amountAdvance: "0" },
      { dfPaid: "0" },
      { cfPaid: "0" },
      { creditCardFee: "0" },
      { creditCost: "0" },
      { dfNet: "0" },
      { cfNet: "0" },
      { dfOverdue: "0" },
      { cfOverdue: "0" },
      { overdue: "0" },
      { staff: "0" },
      { remark: "0" },
      { cancelRemark: "0" },
      { cancelBy: "0" },
    ]
  }
  const translationMap: Record<string, string> = {
    "datePaid": "วันที่",
    "billStatus": "สถานะใบเสร็จ",
    "billNo": "เลขที่ใบเสร็จ",
    "cnNumber": "รหัสผู้ป่วย",
    "branchCnNumber": "รหัสผู้ป่วยประจำสาขา",
    "snCode": "รหัสผู้ป่วยพิเศษ",
    "patientFullname": "ชื่อผู้ป่วย",
    "doctorFullname": "ทันตแพทย์",
    "itemTypeName": "ประเภทรายการ",
    "code": "รหัส",
    "itemName": "รายการ",
    "price": "ราคาต่อหน่วย",
    "qty": "จำนวน",
    "priceTreatment": "ราคาค่ารักษา",
    "dfPercent": "DF%",
    "dfOriginal": "ยอดค่ารักษา DF",
    "cfPercent": "CF%",
    "cfOriginal": "ยอดค่ารักษา CF",
    "dfDiscount": "ส่วนลดสิทธิการรักษา DF",
    "cfDiscount": "ส่วนลดสิทธิการรักษา CF",
    "discountTotal": "รวมส่วนลด (THB)",
    "additionalTotal": "รวมส่วนเพิ่ม (THB)",
    "dfNetOriginal": "ยอดรวมสุทธิ DF",
    "cfNetOriginal": "ยอดรวมสุทธิ CF",
    "total": "ยอดรวมสุทธิค่ารักษา",
    "PayTreatment": "จ่ายค่ารักษา",
    "amountPaidOverdue": "จ่ายค้างชำระ",
    "amountPaidAdvance": "Advance",
    "amountPaid": "ยอดรับเงินสุทธิ",
    "amountCash": "เงินสด",
    "amountTransfer": "เงินโอน",
    "amountCredit": "เครดิต",
    "amountDebit": "เดบิต",
    "dfAmountCredit": "เครดิต DF",
    "cfAmountCredit": "เครดิต CF",
    "amountTrementRight": "สิทธิการรักษา",
    "amountVoucher": "Gift Voucher",
    "amountPromotion": "Promotion",
    "amountAdvance": "Clear Advance",
    "dfPaid": "จ่ายค่ารักษา DF",
    "cfPaid": "จ่ายค่ารักษา CF",
    "creditCardFee": "เครดิต %",
    "creditCost": "ยอดรวมเครดิต %",
    "dfNet": "DF สุทธิ",
    "cfNet": "CF สุทธิ",
    "dfOverdue": "ค้างชำระ DF",
    "cfOverdue": "ค้างชำระ CF",
    "overdue": "Balance",
    "staff": "staff",
    "remark": "Remark",
    "cancelRemark": "Cancel Remark",
    "cancelBy": "Cancel By"
  };

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = { page: 1, pageLimit: 200 }
    ReportApi.reportList(condition).then(({ data }) => {
      setReportId(_.find(data, (item) => item.reportKey === "TRANSACTION_REVENUE")?.reportId)
      const check = _.find(data, (val: any) => String(val.reportKey) === 'TRANSACTION_REVENUE') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })

    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })

    ClinicApi.allBillPrefix()
      .then((resp) => setReceiptPrefix(resp.data))
      .catch((e) => {
        return
      })

    ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1])
      .then((resp) => {
        setDoctors([{ userId: 0, fullname: t('REPORT.TITLE.NO_DOCTOR') }, ...resp.data])
        const dentists: DentistInterface[] = resp.data.map((d: any) => {
          return {
            dentistId: d.userId,
            dentistFullname: d.fullname
          }
        })
        setSelectDoctors([...dentists.map((d: DentistInterface) => d.dentistId)])
      })
      .catch((e) => {
        return
      })
    // DoctorScheduleApi.findAllDoctor({ branchId: branchId }).then(({ data: dataAllDoctor }) => {
    //   const dentists: DentistInterface[] = dataAllDoctor.map((d: any) => {
    //     return {
    //       dentistId: d.userId,
    //       dentistFullname: d.fullname
    //     }
    //   })
    //   setSelectDoctors([...dentists.map((d: DentistInterface) => d.dentistId)])
    // })
    return true
  }

  const loadOperativeType = useCallback((search = '') => {
    OperativeTypeApi.findAll({ page: 1, status: 'ACTIVE', pageLimit: 50, search: search, showNhso: 1 })
      .then((resp) => setOperativeTypes(resp.data))
      .catch((e) => {
        return
      })
  }, [])

  const loadProductType = useCallback((search = '') => {
    ProductTypesApi.findAll({ page: 1, status: 'ACTIVE', pageLimit: 50, search: search })
      .then((resp) => setProductTypes(resp.data))
      .catch((e) => {
        return
      })
  }, [])

  const loadItemCode = useCallback((search = '', itemTypeId = null, group = ``) => {
    ComponentApi.findAllItemCode({ itemTypeId, group, search: search })
      .then((resp) => setItemCode(resp.data))
      .catch((e) => {
        return
      })
  }, [])

  const handleFilterDoctors = (value: any) => {
    const val = value === 'ALL' ? value : Number(value)
    if ((val === 'ALL' && _.size(selectDoctors.filter((item) => typeof item === 'number')) === _.size(doctors)) || val === 'CLEAR') setSelectDoctors([''])
    else if (val === 'ALL') setSelectDoctors([..._.map(doctors, (d: any) => d.userId)])
    else if (_.includes(selectDoctors, val)) setSelectDoctors(_.filter(selectDoctors, (d) => d !== val))
    else setSelectDoctors([...selectDoctors, val])
  }

  useEffect(() => {
    verifyPermission()
  }, [branchId])

  useEffect(() => {
    loadOperativeType()
    loadProductType()
    loadItemCode()
  }, [loadOperativeType, loadProductType, loadItemCode])

  const fetchTransaction = useCallback(async () => {
    let condition: FindAllReportInterface = {
      page: transactionPage,
      pageLimit: transactionLimitPage,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      operativeType: operativeTypeId,
      groupCode: groupCode,
      group: group,
      patientId: patientId,
      billStatus: billStatus,
      operativeCode: operativeId
    }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
    if (rangeDate) {
      if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }
    if (doctors) {
      const isAllSelected = selectDoctors.includes('ALL')
      const filteredDoctors = isAllSelected ? selectDoctors.filter((doctor) => doctor !== 'ALL') : selectDoctors
      condition = { ...condition, doctorId: filteredDoctors.join(',').replace(/^,|,$/g, '') }
    }

    await ReportApi.reportTransactionRevenue(condition)
      .then(({ headers, data }) => {
        setTransactionData(data)
        setRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
    setFetchData(false)
  }, [branchId, transactionPage, transactionLimitPage, prefix, rangeDate, operativeId, patientId, groupCode, patientId, billStatus, operativeTypeId, doctorId, group, selectDoctors, fetchData])

  const fetchTransactionExport = useCallback(async () => {
    let condition: FindAllReportInterface = {
      page: transactionPage,
      pageLimit: transactionLimitPage,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      operativeType: operativeTypeId,
      groupCode: groupCode,
      group: group,
      patientId: patientId,
      billStatus: billStatus,
      operativeCode: operativeId,
      export: 1
    }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
    if (rangeDate) {
      if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }

    if (doctors) {
      const isAllSelected = selectDoctors.includes('ALL')
      const filteredDoctors = isAllSelected ? selectDoctors.filter((doctor) => doctor !== 'ALL') : selectDoctors
      condition = { ...condition, doctorId: filteredDoctors.join(',').replace(/^,|,$/g, '') }
    }

    await ReportApi.reportTransactionRevenue(condition)
      .then(({ data }) => {
        setTransactionDataExport(data)
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }, [branchId, transactionPage, transactionLimitPage, prefix, rangeDate, operativeId, patientId, groupCode, patientId, billStatus, operativeTypeId, doctorId, group, selectDoctors])
  const { onDownload } = useDownloadExcel({
    tableExportRef: componentRef.current,
    filename: `${t(`REPORT.REPORT_NAME.TRANSACTION_REVENUE`)} ${rangeDate[0] ? `(${rangeDate[0]}-${rangeDate[1]})` : ''}  `,
    sheetName: `${t(`REPORT.REPORT_NAME.TRANSACTION_REVENUE`)} `
  })

  const handleClear = () => setPatientId(0)

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangeRowsPerPage = (limit: number) => setTransactionLimitPage(limit)

  const handleChangePage = (val: number) => setTransactionPage(val)

  useEffect(() => {
    fetchTransaction()
  }, [fetchTransaction])

  useEffect(() => {
    fetchTransactionExport()
  }, [fetchTransactionExport])

  useEffect(() => {
    fetchAboutUs()
  }, [])

  const MAX_SELECTION = crm === '1' ? 25 : 23

  const handleCheckboxChange = (key: string) => {
    // นับจำนวนข้อมูลที่มีค่า "1"
    const selectedCount = transactionRevenueList.filter((item: any) => Object.values(item)[0] === "1").length;

    setTransactionRevenueList((prevList: any) =>
      prevList.map((item: any) => {
        if (Object.keys(item)[0] === key) {
          const newValue = item[key] === "1" ? "0" : "1";
          // ถ้ากดเลือกเพิ่ม และจำนวนที่เลือกครบ 23 แล้ว ให้ return ค่าของเดิม
          if (selectedCount >= MAX_SELECTION && newValue === "1") {
            return item;
          }
          return { [key]: newValue };
        }
        return item;
      })
    );
  };



  // 1. Filter เฉพาะข้อมูลที่มีค่า "1"
  const filteredData = transactionRevenueList.filter((item: any) => Object.values(item)[0] === "1");
  // 2. ดึงชื่อคอลัมน์จาก key ของ object
  const selectedColumns = filteredData.map((item: any) => Object.keys(item)[0]);


  const renderTable = (data: any, index: number) => {

    const result = []
    if (transactionRevenueList[0]?.datePaid === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{dateTimeToView(data.datePaid)}</TableCell>)
    if (transactionRevenueList[1]?.billStatus === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{t(`REPORT.BILL_STATUS.${data.billStatus}`)}</TableCell>)
    if (transactionRevenueList[2]?.billNo === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.billNo} {(data?.isNhso === '1' ? <span style={{ color: '#2F4169', fontSize: 12, fontWeight: "bold" }}>{` (สปสช.) `}</span> : '')} </TableCell>)
    if (transactionRevenueList[3]?.cnNumber === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.cnNumber}</TableCell>)
    if (transactionRevenueList[4]?.branchCnNumber === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.branchCnNumber}</TableCell>)
    if (transactionRevenueList[5]?.snCode === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.snCode}</TableCell>)
    if (transactionRevenueList[6]?.patientFullname === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.patientFullname}</TableCell>)
    if (transactionRevenueList[7]?.doctorFullname === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.doctorFullname}</TableCell>)
    if (transactionRevenueList[8]?.itemTypeName === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.itemTypeName}</TableCell>)
    if (transactionRevenueList[9]?.code === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.code}</TableCell>)
    if (transactionRevenueList[10]?.itemName === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data.itemName}</TableCell>)
    if (transactionRevenueList[11]?.price === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400, }}>{numberFormat(data?.price)}</TableCell>)
    if (transactionRevenueList[12]?.qty === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(1)}</TableCell>)
    if (transactionRevenueList[13]?.priceTreatment === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.price * data?.qty)}</TableCell>)
    if (transactionRevenueList[14]?.dfPercent === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.dfUnit === 'PERCENT' ? data.dfPercentOriginal + '%' : data.dfBahtOriginal + 'บาท' || '-'}</TableCell>)
    if (transactionRevenueList[15]?.dfOriginal === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfOriginal)}</TableCell>)
    if (transactionRevenueList[16]?.cfPercent === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.dfUnit === 'PERCENT' ? data.cfPercentOriginal + '%' : data.cfBahtOriginal + 'บาท' || '-'}</TableCell>)
    if (transactionRevenueList[17]?.cfOriginal === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfOriginal)}</TableCell>)
    if (transactionRevenueList[18]?.dfDiscount === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfDiscount)}</TableCell>)
    if (transactionRevenueList[19]?.cfDiscount === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfDiscount)}</TableCell>)
    if (transactionRevenueList[20]?.discountTotal === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.discountTotal)}</TableCell>)
    if (transactionRevenueList[21]?.additionalTotal === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.additionalTotal)}</TableCell>)
    if (transactionRevenueList[22]?.dfNetOriginal === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfNetOriginal)}</TableCell>)
    if (transactionRevenueList[23]?.cfNetOriginal === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfNetOriginal)}</TableCell>)
    if (transactionRevenueList[24]?.total === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.total)}</TableCell>)
    if (transactionRevenueList[25]?.PayTreatment === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountPaid)}</TableCell>)
    if (transactionRevenueList[26]?.amountPaidOverdue === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountPaidOverdue)}</TableCell>)
    if (transactionRevenueList[27]?.amountPaidAdvance === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountPaidAdvance)}</TableCell>)
    if (transactionRevenueList[28]?.amountPaid === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountPaid)}</TableCell>)
    if (transactionRevenueList[29]?.amountCash === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountCash)}</TableCell>)
    if (transactionRevenueList[30]?.amountTransfer === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountTransfer)}</TableCell>)
    if (transactionRevenueList[31]?.amountCredit === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountCredit)}</TableCell>)
    if (transactionRevenueList[32]?.amountDebit === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountDebit)}</TableCell>)
    if (transactionRevenueList[33]?.dfAmountCredit === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfAmountCredit)}</TableCell>)
    if (transactionRevenueList[34]?.cfAmountCredit === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfAmountCredit)}</TableCell>)
    if (transactionRevenueList[35]?.amountTrementRight === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountTrementRight)}</TableCell>)
    if (crm === '1') {
      if (transactionRevenueList[36]?.amountVoucher === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountVoucher)}</TableCell>)
      if (transactionRevenueList[37]?.amountPromotion === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountPromotion)}</TableCell>)
      if (transactionRevenueList[38]?.amountAdvance === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountAdvance)}</TableCell>)
      if (transactionRevenueList[39]?.dfPaid === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfPaid)}</TableCell>)
      if (transactionRevenueList[40]?.cfPaid === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfPaid)}</TableCell>)
      if (transactionRevenueList[41]?.creditCardFee === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data.creditCardFee, 3, 3) || '-'}</TableCell>)
      if (transactionRevenueList[42]?.creditCost === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data.creditCost, 3, 3) || '-'}</TableCell>)
      if (transactionRevenueList[43]?.dfNet === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfNet)}</TableCell>)
      if (transactionRevenueList[44]?.cfNet === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfNet)}</TableCell>)
      if (transactionRevenueList[45]?.dfOverdue === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfOverdue)}</TableCell>)
      if (transactionRevenueList[46]?.cfOverdue === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfOverdue)}</TableCell>)
      if (transactionRevenueList[47]?.overdue === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.overdue)}</TableCell>)
      if (transactionRevenueList[48]?.staff === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.staff}</TableCell>)
      if (transactionRevenueList[49]?.remark === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.remark || '-'}</TableCell>)
      if (transactionRevenueList[50]?.cancelRemark === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.cancelRemark || '-'}</TableCell>)
      if (transactionRevenueList[51]?.cancelBy === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.cancelBy || '-'}</TableCell>)
    } else {
      if (transactionRevenueList[36]?.amountAdvance === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.amountAdvance)}</TableCell>)
      if (transactionRevenueList[37]?.dfPaid === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfPaid)}</TableCell>)
      if (transactionRevenueList[38]?.cfPaid === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfPaid)}</TableCell>)
      if (transactionRevenueList[39]?.creditCardFee === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data.creditCardFee, 3, 3) || '-'}</TableCell>)
      if (transactionRevenueList[40]?.creditCost === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data.creditCost, 3, 3) || '-'}</TableCell>)
      if (transactionRevenueList[41]?.dfNet === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfNet)}</TableCell>)
      if (transactionRevenueList[42]?.cfNet === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfNet)}</TableCell>)
      if (transactionRevenueList[43]?.dfOverdue === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.dfOverdue)}</TableCell>)
      if (transactionRevenueList[44]?.cfOverdue === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.cfOverdue)}</TableCell>)
      if (transactionRevenueList[45]?.overdue === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{numberFormat(data?.overdue)}</TableCell>)
      if (transactionRevenueList[46]?.staff === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.staff}</TableCell>)
      if (transactionRevenueList[47]?.remark === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.remark || '-'}</TableCell>)
      if (transactionRevenueList[48]?.cancelRemark === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.cancelRemark || '-'}</TableCell>)
      if (transactionRevenueList[49]?.cancelBy === '1') result.push(<TableCell sx={{ fontSize: '16px', fontWeight: 400 }}>{data?.cancelBy || '-'}</TableCell>)
    }
    return result.length > 0 ? result : null
  }

  const stylePDF = (index: number) => {
    switch (translationMap[selectedColumns[index]]) {
      case 'วันที่':
        return { minWidth: "39px", maxWidth: "39px" }
      case 'สถานะใบเสร็จ':
        return { minWidth: "39px", maxWidth: "39px" }
      case 'เลขที่ใบเสร็จ':
        return { minWidth: "40px", maxWidth: "40px" }
      // case 'รหัสผู้ป่วย':
      //   return { width: "52px" }
      //   case 'รหัสผู้ป่วยประจำสาขา':
      // return { width: "52px" }
      // case 'รหัสผู้ป่วยพิเศษ':
      // return { width: "52px" }
      case 'ชื่อผู้ป่วย':
        return { minWidth: "47px" }
      case 'ทันตแพทย์':
        return { minWidth: "47px" }
      case 'ประเภทรายการ':
        return { minWidth: "55px", }
      case 'รหัส':
        return { minWidth: "29px", maxWidth: "29px" }
      case 'รายการ':
        return { minWidth: "55px" }
      case 'ราคาต่อหน่วย':
        return { minWidth: "38px", maxWidth: "38px" }
      case 'จำนวน':
        return { minWidth: "23px", maxWidth: "23px" }
      case 'ราคาค่ารักษา':
        return { minWidth: "38px", maxWidth: "38px" }
      // case 'DF%':
      //   return { width: "16px" }
      // case 'ยอดค่ารักษา DF':
      //   return { width: "16px" }
      // case 'CF%':
      //   return { width: "16px" }
      // case 'ยอดค่ารักษา CF':
      //   return { width: "16px" }
      // case 'ส่วนลดสิทธิการรักษา DF':
      //   return { width: "33px" }
      // case 'ส่วนลดสิทธิการรักษา CF':
      //   return { width: "33px" }
      case 'รวมส่วนลด (THB)':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'รวมส่วนเพิ่ม (THB)':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'ยอดรวมสุทธิ DF':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'ยอดรวมสุทธิ CF':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'ยอดรวมสุทธิค่ารักษา':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'จ่ายค่ารักษา':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'จ่ายค้างชำระ':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'Advance':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'ยอดรับเงินสุทธิ':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'เงินสด':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'เงินโอน':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'เครดิต':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'เดบิต':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'เครดิต DF':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'เครดิต CF':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'สิทธิการรักษา':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'Gift Voucher':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'Promotion':
        return { minWidth: '37px', maxWidth: '37px', letterSpacing: '0px' }
      case 'Clear Advance':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'จ่ายค่ารักษา DF':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'จ่ายค่ารักษา CF':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'เครดิต %"':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'ยอดรวมเครดิต %':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'DF สุทธิ':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'CF สุทธิ':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'ค้างชำระ DF':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'ค้างชำระ CF':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'Balance':
        return { minWidth: '35px', maxWidth: '35px', letterSpacing: '0px' }
      case 'staff':
        return { minWidth: '35px', maxWidth: '100px', letterSpacing: '0px' }
      case 'Remark':
        return { minWidth: '35px', maxWidth: '100px', letterSpacing: '0px' }
      case 'Cancel Remark':
        return { minWidth: '35px', maxWidth: '100px', letterSpacing: '0px' }
      case 'Cancel By':
        return { minWidth: '35px', maxWidth: '100px', letterSpacing: '0px' }
      default:
        break;
    }
  }

  const onSubmitPDF = async () => {
    await setIsOpenModal(false)
    await ReportPermissionApi.PatchReportTransactionRevenueList(branchId, { reportId: reportId, permission: transactionRevenueList })
    const style = document.createElement("style");
    style.innerHTML = `
                      @media print {
                        @page { size: landscape }
                      }
                    `;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  }

  const renderTablePDF = (data: any) => {
    const result = []
    if (transactionRevenueList[0]?.datePaid === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', maxWidth: '39px', fontWeight: 400, textAlign: 'center', width: '125px', border: '1px solid black' }}>{dateTimeToView(data.datePaid)}</td>)
    if (transactionRevenueList[1]?.billStatus === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', maxWidth: '39px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black' }}>{t(`REPORT.BILL_STATUS.${data.billStatus}`)}</td>)
    if (transactionRevenueList[2]?.billNo === '1') result.push(<td style={{ fontSize: '8.5px', maxWidth: '39px', letterSpacing: '0px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black' }}>{data.billNo} {(data?.isNhso === '1' ? <span style={{ color: '#2F4169', fontSize: 7 }}>{` (สปสช.) `}</span> : '')}</td>)
    if (transactionRevenueList[3]?.cnNumber === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '0px', fontWeight: 400, textAlign: 'center', width: '125px', border: '1px solid black' }}>{data.cnNumber}</td>)
    if (transactionRevenueList[4]?.branchCnNumber === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '0px', fontWeight: 400, textAlign: 'center', width: '125px', border: '1px solid black' }}>{data.branchCnNumber}</td>)
    if (transactionRevenueList[5]?.snCode === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '0px', fontWeight: 400, textAlign: 'center', width: '125px', border: '1px solid black' }}>{data.snCode || '-'}</td>)
    if (transactionRevenueList[6]?.patientFullname === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '0px', maxWidth: '47px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black' }}>{data.patientFullname}</td>)
    if (transactionRevenueList[7]?.doctorFullname === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '0px', maxWidth: '47px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black' }}>{data.doctorFullname}</td>)
    if (transactionRevenueList[8]?.itemTypeName === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '0px', maxWidth: '57px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black' }}>{data.itemTypeName}</td>)
    if (transactionRevenueList[9]?.code === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '0px', maxWidth: '29px', fontWeight: 400, textAlign: 'center', width: '125px', border: '1px solid black' }}>{data.code}</td>)
    if (transactionRevenueList[10]?.itemName === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '0px', maxWidth: '57px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black' }}>{data.itemName}</td>)
    if (transactionRevenueList[11]?.price === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', maxWidth: '38px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data?.price)}</td>)
    if (transactionRevenueList[12]?.qty === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', maxWidth: '23px', fontWeight: 400, textAlign: 'center', width: '125px', border: '1px solid black' }}>{data?.qty}</td>)
    if (transactionRevenueList[13]?.priceTreatment === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', maxWidth: '38px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data?.price * data?.qty)}</td>)
    if (transactionRevenueList[14]?.dfPercent === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{data?.dfUnit === 'PERCENT' ? data.dfPercentOriginal + '%' : data.dfBahtOriginal + 'บาท' || '-'}</td>)
    if (transactionRevenueList[15]?.dfOriginal === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data?.dfOriginal)}</td>)
    if (transactionRevenueList[16]?.cfPercent === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{data?.dfUnit === 'PERCENT' ? data.cfPercentOriginal + '%' : data.cfBahtOriginal + 'บาท' || '-'}</td>)
    if (transactionRevenueList[17]?.cfOriginal === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.cfOriginal || 0)}</td>)
    if (transactionRevenueList[18]?.dfDiscount === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.dfDiscount)}</td>)
    if (transactionRevenueList[19]?.cfDiscount === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.cfDiscount)}</td>)
    if (transactionRevenueList[20]?.discountTotal === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.discountTotal)}</td>)
    if (transactionRevenueList[21]?.additionalTotal === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.additionalTotal)}</td>)
    if (transactionRevenueList[22]?.dfNetOriginal === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.dfNetOriginal)}</td>)
    if (transactionRevenueList[23]?.cfNetOriginal === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.cfNetOriginal)}</td>)
    if (transactionRevenueList[24]?.total === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.total)}</td>)
    if (transactionRevenueList[25]?.PayTreatment === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountPaid)}</td>)
    if (transactionRevenueList[26]?.amountPaidOverdue === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountPaidOverdue)}</td>)
    if (transactionRevenueList[27]?.amountPaidAdvance === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountPaidAdvance)}</td>)
    if (transactionRevenueList[28]?.amountPaid === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountPaid)}</td>)
    if (transactionRevenueList[29]?.amountCash === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountCash)}</td>)
    if (transactionRevenueList[30]?.amountTransfer === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountTransfer)}</td>)
    if (transactionRevenueList[31]?.amountCredit === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountCredit)}</td>)
    if (transactionRevenueList[32]?.amountDebit === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountDebit)}</td>)
    if (transactionRevenueList[33]?.dfAmountCredit === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.dfAmountCredit)}</td>)
    if (transactionRevenueList[34]?.cfAmountCredit === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.cfAmountCredit)}</td>)
    if (transactionRevenueList[35]?.amountTrementRight === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountTrementRight)}</td>)
    if (crm === '1') {
      if (transactionRevenueList[36]?.amountVoucher === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountVoucher)}</td>)
      if (transactionRevenueList[37]?.amountPromotion === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '37px' }}>{numberFormat(data?.amountPromotion)}</td>)
      if (transactionRevenueList[38]?.amountAdvance === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountAdvance)}</td>)
      if (transactionRevenueList[39]?.dfPaid === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.dfPaid)}</td>)
      if (transactionRevenueList[40]?.cfPaid === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.cfPaid)}</td>)
      if (transactionRevenueList[41]?.creditCardFee === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data.creditCardFee, 3, 3) || '-'}</td>)
      if (transactionRevenueList[42]?.creditCost === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data.creditCost, 3, 3) || '-'}</td>)
      if (transactionRevenueList[43]?.dfNet === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.dfNet)}</td>)
      if (transactionRevenueList[44]?.cfNet === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.cfNet)}</td>)
      if (transactionRevenueList[45]?.dfOverdue === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.dfOverdue)}</td>)
      if (transactionRevenueList[46]?.cfOverdue === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.cfOverdue)}</td>)
      if (transactionRevenueList[47]?.overdue === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.overdue)}</td>)
      if (transactionRevenueList[48]?.staff === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black', maxWidth: '100px' }}>{data?.staff}</td>)
      if (transactionRevenueList[49]?.remark === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black', maxWidth: '100px' }}>{data?.remark || '-'}</td>)
      if (transactionRevenueList[50]?.cancelRemark === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black', maxWidth: '100px' }}>{data?.cancelRemark || '-'}</td>)
      if (transactionRevenueList[51]?.cancelBy === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black', maxWidth: '100px' }}>{data?.cancelBy || '-'}</td>)
    } else {
      if (transactionRevenueList[36]?.amountAdvance === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.amountAdvance)}</td>)
      if (transactionRevenueList[37]?.dfPaid === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.dfPaid)}</td>)
      if (transactionRevenueList[38]?.cfPaid === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data?.cfPaid)}</td>)
      if (transactionRevenueList[39]?.creditCardFee === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black', maxWidth: '35px' }}>{numberFormat(data.creditCardFee, 3, 3) || '-'}</td>)
      if (transactionRevenueList[40]?.creditCost === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data.creditCost, 3, 3) || '-'}</td>)
      if (transactionRevenueList[41]?.dfNet === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data?.dfNet)}</td>)
      if (transactionRevenueList[42]?.cfNet === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data?.cfNet)}</td>)
      if (transactionRevenueList[43]?.dfOverdue === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data?.dfOverdue)}</td>)
      if (transactionRevenueList[44]?.cfOverdue === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data?.cfOverdue)}</td>)
      if (transactionRevenueList[45]?.overdue === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'right', width: '125px', border: '1px solid black' }}>{numberFormat(data?.overdue)}</td>)
      if (transactionRevenueList[46]?.staff === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black', maxWidth: '100px' }}>{data?.staff}</td>)
      if (transactionRevenueList[47]?.remark === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black', maxWidth: '100px' }}>{data?.remark || '-'}</td>)
      if (transactionRevenueList[48]?.cancelRemark === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black', maxWidth: '100px' }}>{data?.cancelRemark || '-'}</td>)
      if (transactionRevenueList[49]?.cancelBy === '1') result.push(<td style={{ fontSize: '8.5px', letterSpacing: '-0.6px', fontWeight: 400, textAlign: 'left', width: '125px', border: '1px solid black', maxWidth: '100px' }}>{data?.cancelBy || '-'}</td>)
    }
    return result.length > 0 ? result : null
  }
  return (
    <Box>
      <PageModal
        isOpen={isOpenModal}
        overflow
        size='M'
        title={`ส่งออกตารางเป็น PDF`}
        handleClose={() => setIsOpenModal(false)}
        onCancel={{ onClick: () => setIsOpenModal(false) }}
        onSubmit={{ onClick: () => onSubmitPDF() }}
      >
        <Box>
          <FilterSelect
            formControlClass={'filter filter-headCells'}
            formControlStyle={{ maxWidth: 'unset !important' }}
            label={t('REPORT.FILTER.COLUMN_EXPORT')}
            selectId="select-headCells"
            labelId="label-headCells"
            fullWidth
            multiple
            heightDropdown={400}
            value={transactionRevenueList}
            renderValue={() => {
              return transactionRevenueList
                .filter((item: any) => {
                  const value = Object.values(item)[0];  // ดึงค่า value ของ object
                  return value === "1"; // เฉพาะที่มีค่าเป็น "1"
                })
                .map((item: any) => translationMap[Object.keys(item)[0]]) // ดึง key ของแต่ละ item
                .join(", ")
            }}
            options={[
              <div key="box">

                <Typography fontSize="14px" fontWeight={400} color="red" marginLeft="24px" marginTop="16px">
                  {`หมายเหตุ : สามารถเลือกได้สูงสุด ${MAX_SELECTION} รายการ (${transactionRevenueList.filter((item: any) => Object.values(item)[0] === "1").length}/${MAX_SELECTION})`}
                </Typography>
                <div key="group-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)' }}>
                  {_.map(transactionRevenueList, (item, index) => {
                    const key = Object.keys(item)[0];
                    const isChecked = item[key] === "1";
                    const selectedCount = transactionRevenueList.filter((item: any) => Object.values(item)[0] === "1").length;
                    const isDisabled = selectedCount >= MAX_SELECTION && !isChecked; // ถ้าครบ 23 อันแล้ว ห้ามติ๊กเพิ่ม
                    return (
                      <MenuItem key={index} value={key} style={{ display: "flex", alignItems: "center" }} disabled={isDisabled} onClick={() => handleCheckboxChange(key)}>
                        <InputCheckbox
                          value={key}
                          checked={isChecked}
                          disabled={isDisabled}
                        />
                        {translationMap[key]}
                      </MenuItem>
                    )
                  })}
                </div>
              </div>
            ]}
          />
          <Box sx={{ overflowX: 'auto', overflowY: 'hidden', marginTop: '16px' }}>
            <TableContainer style={{ boxShadow: 'none', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
              <Table aria-label="simple table" sx={{ width: '100%' }}>
                <TableHead sx={{ backgroundColor: "#2F4269", color: 'white !important', border: '1px solid #2F4269' }}>
                  <TableRow>
                    {_.map(filteredData, (_item, index) => (
                      <TableCell sx={{ color: "white !important", fontWeight: 500, minWidth: '200px' }}>{translationMap[selectedColumns[index]]}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(transactionData?.rows, (item, index: number) =>
                    <TableRow key={index} style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)', borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
                      {renderTable(item, index)}
                    </TableRow>)}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* <TransactionRevenuePDF filterData={filteredData} transactionData={transactionData} translationMap={translationMap} selectedColumns={selectedColumns} /> */}
        </Box>
      </PageModal>
      <HeaderCard text={t(`REPORT.REPORT_NAME.TRANSACTION_REVENUE`)} />
      <Box padding="16px">
        <Grid container spacing="8px">
          <Grid item sm={6} md={4} xl={3}>
            <SearchPatients
              status="ACTIVE"
              callbackPatientId={setPatientId}
              patientId={patientId}
              onClear={handleClear}
              callbackPatientName={(value) => {
                setPatientFilter(value)
              }}
            />
          </Grid>
          <Grid item sm={6} md={4} xl={3}>
            <FilterSelect
              onchange={(e) => {
                setBranchId(e.target.value)
                setTransactionPage(1)
              }}
              renderValue={() => `${t('REPORT.FILTER.BRANCH')}: ${_.get(_.find(branches, { branchId: branchId }), 'branchName' || 'branchNameEn')} `}
              label={''}
              selectId="select-branch"
              labelId="label-branch"
              value={branchId}
              options={_.map(branches, (b: BranchInterface) => {
                return (
                  <MenuItem key={b.branchId} value={b.branchId}>
                    {b.branchName || b.branchNameEn}
                  </MenuItem>
                )
              })}
              formControlStyle={{ maxWidth: 'unset !important' }}
              classesOption="style-select-doctors"
            />
          </Grid>
          <Grid item sm={6} md={4} xl={3}>
            <InputSecondNewRangePicker
              inputHeight={32}
              value={rangeDate || emptyRangePicker}
              onchange={(val: any) => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                setTransactionPage(1)
              }}
              label={''}
              allowClear
              onClear={() => setRangeDate(emptyRangePicker)}
            />
          </Grid>
          <Grid item sm={6} md={4} xl={3}>
            <FilterSelect
              onchange={(e) => {
                setBillStatus(e.target.value)
                setTransactionPage(1)
              }}
              renderValue={() => `${t('REPORT.FILTER.RECEIPT_STATUS')}: ${billStatus === 'ALL' ? t(`REPORT.FILTER.ALL`) : t(`REPORT.FILTER.BILL.${billStatus}`)} `}
              label={''}
              selectId="select-bill-status"
              labelId="label-bill-status"
              value={billStatus}
              options={[
                <MenuItem key="1" value="ALL">
                  {t('REPORT.FILTER.ALL')}
                </MenuItem>,
                <MenuItem key="2" value="NORMAL">
                  {t('REPORT.FILTER.BILL.NORMAL')}
                </MenuItem>,
                <MenuItem key="3" value="CANCEL">
                  {t('REPORT.FILTER.BILL.CANCEL')}
                </MenuItem>
              ]}
              formControlStyle={{ maxWidth: 'unset !important' }}
              classesOption="style-select-doctors"
            />
          </Grid>
          <Grid item sm={6} md={4} xl={3}>
            <FilterSelect
              onchange={(e) => {
                setPrefix(e.target.value)
                setTransactionPage(1)
              }}
              renderValue={() => `${t('REPORT.FILTER.RECEIPT_TYPE')}: ${prefix === 'ALL' ? t(`REPORT.FILTER.ALL`) : prefix} `}
              label={''}
              selectId="select-prefix"
              labelId="label-prefix"
              value={prefix}
              options={[
                <MenuItem key="0" value="ALL">
                  {t('REPORT.FILTER.ALL')}
                </MenuItem>,
                _.map(receiptPrefix, (data: BillInterface) => {
                  return (
                    <MenuItem key={data.billPrefixId} value={data.prefix}>
                      {data.prefix}
                    </MenuItem>
                  )
                }),
                <MenuItem key="0" value="AD">
                  {t('AD')}
                </MenuItem>
              ]}
              formControlStyle={{ maxWidth: 'unset !important' }}
              classesOption="style-select-doctors"
            />
          </Grid>
          <Grid item sm={6} md={4} xl={3}>
            <AutocompleteSelect
              key={'operative'}
              height={32}
              labelId="select-operative-type"
              inputLabel={t('REPORT.FILTER.OPERATIVE_TYPE')}
              noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
              options={[{ productTypeName: t('REPORT.REPORT_GROUP.ALL'), productTypeId: 0 }, ...productTypes, ...operativeTypes]}
              getOptionLabel={(option: any) => option.productTypeName || option.operativeTypeName || ''}
              renderOption={(props, option: any) => (
                <Box key={option} component="li" {...props}>
                  {option.productTypeName || option.operativeTypeName}
                </Box>
              )}
              onchange={(e, value: any) => {
                const id = value?.productTypeId || value?.operativeTypeId || ''
                const gr = value ? value?.group || 'OPERATIVE' : ''
                const name = value?.productTypeName || value?.operativeTypeName || ''
                setOperativeTypeId(id)
                setGroup(value?.group || '')
                setOperativeId(0)
                setTypeSelected({ productTypeName: name, productTypeId: id || 0, group: gr })
                loadItemCode(``, id, gr)
              }}
              inputProps={{
                onChange: (e: any) => {
                  if (productTypes.length === 50 || operativeTypes.length === 50) {
                    setOperativeTypeId(0)
                    setGroup('')
                    setOperativeId(0)
                    if (productTypes.length === 50) {
                      setProductTypes([])
                      loadProductType(e.target.value)
                    }
                    if (operativeTypes.length === 50) {
                      setOperativeTypes([])
                      loadOperativeType(e.target.value)
                    }
                  }
                }
              }}
              onOpen={(e: any) => {
                setOperativeTypeId(0)
                setGroup('')
                setOperativeId(0)
                setTypeSelected({ productTypeName: '', productTypeId: 0, group: '' })
                setCodeSelected({ productCode: ``, productId: 0, group: `` })
                loadProductType()
                loadOperativeType()
              }}
              value={typeSelected}
              disableClearable
            />
          </Grid>
          <Grid item sm={6} md={4} xl={3}>
            <AutocompleteSelect
              key={'operative-code'}
              height={32}
              labelId="operative-code"
              inputLabel={t('REPORT.FILTER.OPERATIVE_CODE')}
              noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
              options={[{ productCode: t('REPORT.REPORT_GROUP.ALL'), productId: 0, group: '' }, ...itemCode]}
              getOptionLabel={(option) => option.productCode}
              renderOption={(props, option) => (
                <Box key={option} component="li" {...props}>
                  {option.productCode}
                </Box>
              )}
              onchange={(e, value) => {
                if (value) {
                  setOperativeId(value.productId || 0)
                  setGroupCode(value.group !== 'OPERATIVE' ? value.group : '')
                  setCodeSelected(value)
                } else {
                  setOperativeId(0)
                  setGroupCode('')
                }
              }}
              inputProps={{
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  setOperativeId(0)
                  setGroupCode('')
                  setItemCode([])

                  loadItemCode(e.target.value)
                }
              }}
              onOpen={(e) => {
                setOperativeId(0)
                setGroupCode('')
                setCodeSelected({ productCode: '', productId: 0, group: '' })
                // loadItemCode()
              }}
              value={codeSelected}
              disableClearable
            />
          </Grid>
          <Grid item sm={6} md={4} xl={3}>
            <ClickAwayListener onClickAway={() => setOpenFilterDoctors(false)}>
              <CustomFilterDoctor open={openFilterDoctors} onClick={() => setOpenFilterDoctors(true)}>
                <AutocompleteSelect
                  open={openFilterDoctors}
                  multiple
                  labelId="label-doctors"
                  options={['ALL', ...doctors, 'CLEAR']}
                  getOptionLabel={(option) => _.find(doctors, { userId: option.userId })?.fullname || '-'}
                  renderOption={(props, option) => {
                    if (option === 'ALL') {
                      return (
                        <ListFilterDoctors {...props} key={option} component="li" value={option}>
                          <InputCheckbox
                            label={t('REPORT.REPORT_GROUP.ALL')}
                            checked={_.size(selectDoctors.filter((item) => typeof item === 'number')) === _.size(doctors)}
                            indeterminate={_.size(selectDoctors) > 1 && _.size(selectDoctors.filter((item) => typeof item === 'number')) !== _.size(doctors)}
                            className={'pe-none'}
                          />
                        </ListFilterDoctors>
                      )
                    } else if (option === 'CLEAR') {
                      return (
                        <Box {...props} key={option} component="li" value={option} sx={{ borderTop: `1px solid ${colors.lightGray}` }}>
                          <SpanClearFilter className="pe-none">{t('REPORT.FILTER.CLEAR_FILTER')}</SpanClearFilter>
                        </Box>
                      )
                    } else {
                      return (
                        <ListFilterDoctors {...props} key={option.userId} component="li" value={option.userId}>
                          <InputCheckbox label={option.fullname} checked={_.includes(selectDoctors, option.userId)} className={'pe-none'} />
                        </ListFilterDoctors>
                      )
                    }
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    return (
                      <>
                        <span className="pr-1">{t('USER_DOCTOR')}:</span>
                        {!openFilterDoctors &&
                          ((_.size(tagValue.filter((item: any) => typeof item === 'number')) === _.size(doctors) && <span>{t('REPORT.REPORT_GROUP.ALL')}</span>) || (
                            <Box className="text-ellipsis">
                              {_.map(tagValue, (option: any, index: number) => {
                                return (
                                  <span>
                                    {_.find(doctors, { userId: option })?.fullname || ''}
                                    {(index !== _.findLastIndex(tagValue) && option && `,`) || ''}
                                  </span>
                                )
                              })}
                            </Box>
                          ))}
                      </>
                    )
                  }}
                  onchange={(e, value) => handleFilterDoctors(e?.target?.value || e?.target?.attributes?.value?.value)}
                  noOptionsText={t('NOT_FOUND')}
                  filterOptions={(option) => 'ALL' + option.fullname + 'CLEAR'}
                  value={selectDoctors}
                  height={32}
                  disableClearable
                />
              </CustomFilterDoctor>
            </ClickAwayListener>
          </Grid>
          <Grid xl={12}>
            <Box display="flex" justifyContent="end" alignItems="center" marginY="8px">
              <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                if (e === 'Excel') onDownload()
                if (e === 'PDF') {
                  // const style = document.createElement("style");
                  // style.innerHTML = `
                  //     @media print {
                  //       @page { size: landscape }
                  //     }
                  //   `;
                  // document.head.appendChild(style);
                  // window.print();
                  // document.head.removeChild(style);
                  setIsOpenModal(true)
                }
              }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
            </Box>
          </Grid>
        </Grid>
        <Box>
          <TransactionRevenueList
            tableFilter={getAllFilter()}
            page={transactionPage}
            pageLimit={transactionLimitPage}
            rowCount={rowCount}
            sortBy={sortBy}
            sortType={sortType}
            data={transactionData}
            onRequestSort={onRequestSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            componentRef={componentRef}
            exportData={transactionDataExport}
            billStatus={billStatus}
            calculateAdvance={_.get(_.find(branches, { branchId: branchId }), 'calculateAdvance') === 'DECREASE'}
          />
        </Box>
        <Box
          id="print-table-container"
          ref={componentRefPDF}
        >
          <Typography fontSize="10px" fontWeight='bold'>{t('REPORT.REPORT_NAME.TRANSACTION_REVENUE')}</Typography>
          <Box display="flex" flexDirection="row" alignItems="center" marginY="8px">
            <Typography fontSize="10px" fontWeight={600} marginRight="4px">{getAllFilter()?.[0]?.[2]}:</Typography>
            <Typography fontSize="10px" fontWeight={400} marginRight="16px">{getAllFilter()?.[0]?.[3]}</Typography>
            <Typography fontSize="10px" fontWeight={600} marginRight="4px">{getAllFilter()?.[1]?.[0]}:</Typography>
            <Typography fontSize="10px" fontWeight={400} marginRight="16px">{getAllFilter()?.[1]?.[1]}</Typography>
            <Typography fontSize="10px" fontWeight={600} marginRight="4px">{getAllFilter()?.[1]?.[2]}:</Typography>
            <Typography fontSize="10px" fontWeight={400} marginRight="16px">{getAllFilter()?.[1]?.[3]}</Typography>
            <Typography fontSize="10px" fontWeight={600} marginRight="4px">{getAllFilter()?.[0]?.[8]}:</Typography>
            <Typography fontSize="10px" fontWeight={400} marginRight="16px">{getAllFilter()?.[0]?.[9]}</Typography>
            <Typography fontSize="10px" fontWeight={600} marginRight="4px">{getAllFilter()?.[0]?.[4]}-{getAllFilter()?.[0]?.[6]}:</Typography>
            <Typography fontSize="10px" fontWeight={400} marginRight="16px">{getAllFilter()?.[0]?.[5]} - {getAllFilter()?.[0]?.[7]}</Typography>
          </Box>
          <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ textAlign: 'center', fontSize: '8.5px', fontWeight: 800, backgroundColor: '#C1C4C5' }}>
                {_.map(filteredData, (_item, index: number) => (
                  <th style={{ ...stylePDF(index), border: '1px solid black', letterSpacing: '0px' }}>{translationMap[selectedColumns[index]]}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {_.map(transactionData?.rows, (item, index: number) =>
                <tr key={index}>
                  {renderTablePDF(item)}
                </tr>)}
            </tbody>
          </table>
          <TransactionRevenueAll data={transactionData} billStatus={billStatus} exportData={transactionDataExport} calculateAdvance={_.get(_.find(branches, { branchId: branchId }), 'calculateAdvance') === 'DECREASE'} crm={crm} />
        </Box>
      </Box>
    </Box >
  )
}
